const TransactionDocuments = () => import("Modules/transaction_documents/views/TransactionDocuments");
const TransactionDocumentsForm = () => import("Modules/transaction_documents/views/TransactionDocumentsForm");

export default {
    children: [
        {
            path: "orders",
            name: "transaction_documents",
            component: TransactionDocuments,
            meta: {
                requiresAuth: true,
                title: "lang.transaction_documents",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer",
                ],
                restrict_by_permission: ["transaction_documents.read"],
            },
        },
        {
            path: "order/:id?",
            name: "transaction_document",
            component: TransactionDocumentsForm,
            meta: {
                requiresAuth: true,
                title: "lang.transaction_documents",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "customer",
                ],
                restrict_by_permission: ["transaction_documents.read"],
            },
        },
    ],
};
